export default {
    hospital: '洪雅县人民医院',
    app_name: '洪雅县人民医院微信公众号',
    max_card: 5,
}